define(function (require) {
    "use strict";

    var LE = require("app");
    //if (sendBox property){
    //require("registration-zoura/sendBoxPostmessage"); currently there is a problem with adding this to the build becuase :  [33m['postMessage'] is better written in dot notation
    //} else {
    //    require("registration-zoura/prodPostmessage");
    //}
    var template = require("registration-templates/buy-now/buyNowCheckout.tmpl");
    var Button = require("ui/button/Button");
    var CheckoutView = {};
    var Loader = require("ui/loader/Loader");
    var Navigator = require("routers/navigator");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");
    var ZuoraPostMessage = require("registration-zuora/postmessage");


    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        var FIELDS = {
            general :{
                codeQueryParameterName: "errorCode",
                messageQueryParameterName: "errorMessage"
            },
            creditCardType :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardType"),
                queryParameterName: "errorField_creditCardType"
            },
            creditCardNumber :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardNumber"),
                queryParameterName: "errorField_creditCardNumber"
            },
            creditCardExpirationMonth :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardExpirationDate"),
                queryParameterName: "errorField_creditCardExpirationMonth"
            },
            creditCardExpirationYear :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardExpirationDate"),
                queryParameterName: "errorField_creditCardExpirationYear"
            },
            cardSecurityCode :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.cardSecurityCode"),
                queryParameterName: "errorField_cardSecurityCode"
            },
            creditCardHolderName :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardHolderName"),
                queryParameterName: "errorField_creditCardHolderName"
            },
            creditCardCountry :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardCountry"),
                queryParameterName: "errorField_creditCardCountry"
            },
            creditCardAddress1 :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardAddress1"),
                queryParameterName: "errorField_creditCardAddress1"
            },
            creditCardCity :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardCity"),
                queryParameterName: "errorField_creditCardCity"
            },
            creditCardState :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardState"),
                queryParameterName: "errorField_creditCardState"
            },
            creditCardPostalCode :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.creditCardPostalCode"),
                queryParameterName: "errorField_creditCardPostalCode"
            },
            phone :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.phone"),
                queryParameterName: "errorField_phone"
            },
            email :{
                name: LE.translator.translate("LERegistration.BuyNowInfo.checkout.email"),
                queryParameterName: "errorField_email"
            }
        };

        var that;

        //this flag is used to let us know if the Iframe was loaded by the controller or by pressing the back button. (LE-LE-10507)
        var newIframeSrcInitiated;

        CheckoutView = Marionette.ItemView.extend({

            className: 'buy-now-checkout-container',

            template: template,

            withUIComponents: true,

            ui: {
                pageTitleLabel: ".page-title-label",
                errorPanel: ".error-panel",
                errorPanelText: ".error-panel .content",
                nextButton: ".next-button",
                cancelButton: ".cancel-button",
                zouraIframe: ".zoura-iframe",
                iframeLoader: ".iframe-loader",
                stepIndicator: ".step-indicator"
            },

            uiComponents: {
                getStartedButton: {
                    type: Button,
                    options: {
                        el: "view.ui.nextButton",
                        permutation:Button.PERMUTATION.BTN_PRIMARY,
                        initState:Button.STATES.ENABLED
                    },
                    events: {
                        "click": next
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": _onClosePage
                    }
                },
                stepIndicator: {
                    type: StepIndicator,
                    options: "stepIndicatorOptions"
                }
            },

            events: {
                'keypress input': 'keyPressEnter'
            },

            initialize: function (options) {
                LERegistration.logger.info("CheckoutView >> initialize >> START");
                this.options = options;
                that = this;
                this.listenTo(this, "page:closeButtonClick", _onClosePage);
                this.flowType= options.flowType;
                LERegistration.logger.info("CheckoutView >> initialize >> END");
            },

            onRender: function () {
                LERegistration.logger.info("CheckoutView >> onRender >> START");
                this.ui.errorPanel.hide();
                this.ui.errorPanelText.text("");
                if (this.options.errors){  //display errors of they exist
                    displayZuoraErrors(this.options.errors);
                }
                newIframeSrcInitiated = true;
                showIframeLoader();
                if(!(LE.sessionManager && LE.sessionManager.getAccountId())) {
                    this.uiComponents.cancelButton.hide();
                }

                LERegistration.logger.info("CheckoutView >> onRender >> END");
            },

            stepIndicatorOptions:function(){
                var hasPersonal= this.model.get("hasPersonal");
                var step= this.flowType === "changePlan" ? (hasPersonal ? "01":"0") : "1";
                return {
                    el: "view.ui.stepIndicator",
                    steps: [
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step" + step), state: StepIndicator.STATE.COMPLETED},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step2"), state: StepIndicator.STATE.CURRENT},
                        { text: LE.translator.translate("LERegistration.BuyNow.stepIndicator.step3"), state: StepIndicator.STATE.NOT_COMPLETED}
                    ]
                };
            }

        });

        function getZuoraErrorsFromQuery(queryParams){
            LERegistration.logger.info("CheckoutView >> getZuoraErrorsFromQuery >> START");
            var errors = {};

            for (var key in FIELDS){
                var field = FIELDS[key];
                if (key === "general"){
                    if(_.has(queryParams, field.codeQueryParameterName) &&
                        _.has(queryParams, field.messageQueryParameterName)){
                        errors[key] = {
                            errorCode : queryParams[field.codeQueryParameterName],
                            errorMessage : queryParams[field.messageQueryParameterName]
                        };
                    }
                } else {
                    if(_.has(queryParams, field.queryParameterName)){
                        //if the error is creditCardExpirationYear we should check there wasn't the error creditCardExpirationMonth to prevent duplication
                        if ( key !== "creditCardExpirationYear" || (key === "creditCardExpirationYear" && !errors.creditCardExpirationMonth)) {
                            errors[key] = {
                                errorMessage: queryParams[field.queryParameterName],
                                name: field.name
                            };
                        }
                    }
                }
            }
            LERegistration.logger.info("CheckoutView >> getZuoraErrorsFromQuery >> END");
            return errors;
        }
        function showLoader(){
            that.loader = new Loader({
                permutation: Loader.PERMUTATION.A,
                el: '.le .reg'
            });
            that.loader.render();
        }

        function closeLoader() {
            LERegistration.logger.info("RegistrationController >> closeLoader >> START");
            if(that.loader){
                that.loader.close();
            }
            LERegistration.logger.info("RegistrationController >> closeLoader >> END");
        }

        function displayZuoraErrors(errors){
            LERegistration.logger.info("CheckoutView >> displayZuoraErrors >> START");
            var errorText = "";

            for (var key in errors){
                var error = errors[key];

                //specific error
                if (_.has(error, "name")){
                    errorText += error.name + ": ";
                    if ( error.errorMessage === "NullValue" ){
                        errorText += LE.translator.translate("LERegistration.FieldMandatory");
                    } else {
                        errorText += LE.translator.translate("LERegistration.FieldNotValid");
                    }
                    errorText += "<br />";
                } else {        //general error
                    if ( error.errorCode === "BusinessValidationError" ){
                        errorText += getGeneralError(error,"Invalid Email","LERegistration.BuyNowInfo.checkout.email","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"Expiration date must be a future date.","LERegistration.BuyNowInfo.checkout.creditCardExpirationDate","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"security code should be numeric.","LERegistration.BuyNowInfo.checkout.cardSecurityCode","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"Invalid Credit Card Number.","LERegistration.BuyNowInfo.checkout.creditCardNumber","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"State/Province should be ISO standard state or province.","LERegistration.BuyNowInfo.checkout.creditCardState","LERegistration.InvalidFiled");
                    } else if ( error.errorCode === "GatewayTransactionError" ){
                        errorText += getGeneralError(error,"Error processing transaction.231 - Invalid account number.","LERegistration.BuyNowInfo.checkout.creditCardNumber","LERegistration.InvalidCreditCardNumber");
                        errorText += getGeneralError(error,"Transaction declined.203 - General decline of the card. No other information provided by the issuing bank.","LERegistration.BuyNowInfo.checkout.creditCardNumber","LERegistration.InvalidCreditCardNumber");
                        errorText += getGeneralError(error,"Error processing transaction.The authorization request was approved by the issuing bank but declined by CyberSource because it did not pass the Address Verification Service (AVS) check.","LERegistration.BuyNowInfo.checkout.creditCardAddress1","LERegistration.VerificationFailed");
                        errorText += getGeneralError(error,"Error processing transaction.CVV Note:The CVN did not match.","LERegistration.BuyNowInfo.checkout.cardSecurityCode","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"Error processing transaction.102 - The following field(s) are invalid: billTo_phoneNumber","LERegistration.BuyNowInfo.checkout.phone","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"Error processing transaction.102 - The following field(s) are invalid: billTo_postalCode","LERegistration.BuyNowInfo.checkout.creditCardPostalCode","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"Error processing transaction.101 - The following required field(s) are missing: billTo_state","LERegistration.BuyNowInfo.checkout.creditCardState","LERegistration.MandatoryField");
                        errorText += getGeneralError(error,"Error processing transaction.102 - The following field(s) are invalid: billTo_lastName","LERegistration.BuyNowInfo.checkout.creditCardHolderName","LERegistration.InvalidFiled");
                        errorText += getGeneralError(error,"Error processing transaction.102 - The following field(s) are invalid: billTo_firstName","LERegistration.BuyNowInfo.checkout.creditCardHolderName","LERegistration.InvalidFiled");
                    } else {
                        if (error.errorCode !== "HostedPageFieldValidationError"){//group all other zuora errors
                            errorText += LE.translator.translate("LERegistration.BuyNowInfo.checkout.zuora.general.error") + "<br />";
                        }
                    }
                }
            }
            that.ui.errorPanelText.html(errorText);
            that.ui.errorPanel.show();
                //$('.next-button .btn-primary').focus();
            LERegistration.logger.info("CheckoutView >> displayZuoraErrors >> END");
        }

        function next() {
            var zuoraReturned= false;
            showLoader();
            that.ui.errorPanel.hide();
            that.ui.errorPanelText.text("");
            if (!window.registrationZhoraCallback) {
                window.registrationZhoraCallback = {};
            }
            window.registrationZhoraCallback.afterSubmit = function (iframeCallbackLocation) {
                zuoraReturned= true;
                var queryParams = Navigator.parseQueryString(false, iframeCallbackLocation);
                closeLoader();
                var errorCode = 603;
                newIframeSrcInitiated = true;
                var returnPage = "buyNow";
                if (_.has(queryParams, "success")){
                    var success = queryParams.success;
                    if (success === "true" && _.has(queryParams, "refId")){
                        that.ui.errorPanelText.html("");
                        that.ui.errorPanel.hide();
                        that.trigger(CheckoutView.TRIGGERING.NEXT_BUTTON_CLICKED, {pmi: queryParams.refId});
                    } else {
                        if (_.has(queryParams, "errorCode") && _.has(queryParams, "errorMessage")){
                            var errors = getZuoraErrorsFromQuery(queryParams);
                            that.trigger(CheckoutView.TRIGGERING.HOSTED_PAGE_VALIDATION_FAILED, errors);
                        } else {
                            LERegistration.router.navigate("error/" + errorCode +"/" + returnPage);
                        }
                    }
                } else {
                    LERegistration.router.navigate("error/" + errorCode +"/" + returnPage);
                }
            };

            window.submitHostedPage("z_hppm_iframe");
            setTimeout(_.bind(function(){
                if(!zuoraReturned){
                    closeLoader();
                    that.trigger(CheckoutView.TRIGGERING.HOSTED_PAGE_TIMEDOUT, this.flowType);
                }
            },that), 30000);
        }

        function getGeneralError(error,errorMessage,fieldNameKey,textFormatKey) {
            LERegistration.logger.info("CheckoutView >> getGeneralError >> START");
            var errorText = "";

            if ( error.errorMessage.indexOf(errorMessage) >= 0 ){
                errorText += LE.translator.translate(textFormatKey).replace("{0}",  LE.translator.translate(fieldNameKey));
                errorText += "<br />";
            }
            LERegistration.logger.info("CheckoutView >> getGeneralError >> END");
            return errorText;
        }

        function showIframeLoader(){
            that.loaderIframe = new Loader({
                permutation: Loader.PERMUTATION.A,
                //el: '.le .reg .buy-now-checkout .container .iframe-loader'
                el: that.ui.iframeLoader
            });
            that.loaderIframe.render();
        }

        function closeIframeLoader() {
            LERegistration.logger.info("CheckoutView >> closeIframeLoader >> START");
            if(that.loaderIframe){
                that.loaderIframe.close();
                that.loaderIframe = null;
            }
            LERegistration.logger.info("CheckoutView >> closeIframeLoader >> END");
        }

        function _onClosePage() {
            LERegistration.logger.info("CheckoutView >> _onClosePage");
            that.trigger(CheckoutView.TRIGGERING.CANCEL_BUTTON_CLICKED);
        }

        window.onZouraIframeLoad = function(){

            if ( !newIframeSrcInitiated ){
                LERegistration.logger.info("CheckoutView >> onZouraIframeLoad >> BACK NEEDED");

                var route= LE.sessionManager && LE.sessionManager.getAccountId() ? "changePlanSelection" : "buyNow";
                LERegistration.router.navigate(route);

            } else {
                newIframeSrcInitiated = false;
            }

            closeIframeLoader();
        };

    });

    CheckoutView.TRIGGERING = {
        NEXT_BUTTON_CLICKED: "next",
        CANCEL_BUTTON_CLICKED: "cancel",
        HOSTED_PAGE_VALIDATION_FAILED: "error"
    };

    return CheckoutView;
});


